
import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { NuevoExhortoLibradoParams, NuevoExhortoLibradoResponse, GuardarExhortoLibradoParams, DetalleExhortoLibradoResponse, ActualizarEstatusParams, ActualizarEstatusResponse, ConsultaExhortosLibradosResponse, ConsultarExhortosLibradosParams, DescargarExhortosLibradosParams, defaultActualizarEstatus, defaultConsultaExhortosLibrados, defaultDetalleExhortoLibrado, defaultNuevoExhortoLibrado } from '../../interfaces/tribunal/ExhortoLibradoInterface';

export const NuevoExhortoLibrado = ( params: NuevoExhortoLibradoParams ) => {

    return new Promise<NuevoExhortoLibradoResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoLibrado/NuevoExhortoLibrado', params, token)
            .then( ({ data } : { data : NuevoExhortoLibradoResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultNuevoExhortoLibrado, message: error.message } );
            });

        }

    });

}

export const GuardarExhortoLibrado = ( params: GuardarExhortoLibradoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoLibrado/GuardarExhortoLibrado', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DetalleExhortoLibrado = ( Id: string ) => {

    return new Promise<DetalleExhortoLibradoResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ExhortoLibrado/DetalleExhortoLibrado/${Id}`, token)
            .then( ({ data } : { data : DetalleExhortoLibradoResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultDetalleExhortoLibrado, message: error.message } );
            });

        }

    });

}

export const ActualizarEstatus = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoLibrado/ActualizarEstatus', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultActualizarEstatus, message: error.message } );
            });

        }

    });

}

export const ConsultarExhortosLibrados = async ( params: ConsultarExhortosLibradosParams ) => {

    return new Promise<ConsultaExhortosLibradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '{}' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/ExhortoLibrado/ConsultarExhortosLibrados', params, token)
            .then(({ data }: { data: ConsultaExhortosLibradosResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve( { ...defaultConsultaExhortosLibrados } );
            });

        }

    });

};

export const DescargarExhortosLibrados = async ( params: DescargarExhortosLibradosParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/ExhortoLibrado/DescargarExhortosLibrados', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

};
